<div
  class="main-container"
  [ngClass]="showDrawer || isMobile ? 'open' : 'closed'"
>
  <div class="header">
    <button
      mat-icon-button
      (click)="onToggleDrawer()"
      class="search-button"
      aria-label="Toggle event search"
    >
      <mat-icon>search</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="onCloseNav()"
      class="close-button"
      aria-label="Close event search"
    >
      <mat-icon>close</mat-icon>
    </button>

    <h2 [class.open]="animation === 'open'">Event Search</h2>
  </div>
  <form
    [formGroup]="searchForm"
    (ngSubmit)="onSubmit()"
    [class.open]="animation === 'open'"
  >
    <mat-label>Event Date</mat-label>
    <mat-form-field>
      <mat-date-range-input [rangePicker]="picker">
        <input
          matStartDate
          formControlName="eventDateStart"
          placeholder="Start Date"
        />
        <input
          matEndDate
          formControlName="eventDateEnd"
          placeholder="End Date"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-label>Event Name</mat-label>
    <mat-form-field>
      <input matInput formControlName="eventName" />
    </mat-form-field>
    <button mat-stroked-button color="accent">Search</button>
  </form>
</div>
